import i18n, { LANGUAGES } from '../i18n';

// A day's name in a language, capitalized as a title: "Sunday", "Domingo". Day 0 is a Sunday.
const dayName = (day, language) => {
  const name = new Date(2026, 10, 1 + day).toLocaleDateString(language, { weekday: 'long' });

  return name.charAt(0).toLocaleUpperCase(language) + name.slice(1);
};

// In every language, so switching languages still lets a day's name follow the date
const isDayName = (title) =>
  LANGUAGES.some(({ id }) => Array.from({ length: 7 }, (unused, day) => dayName(day, id)).includes(title));

// The title a picked date leaves: the day's name while the title is empty or exactly a day's name,
// so picking again follows the date; anything else the user typed is kept.
export function titleForDate(title, date) {
  const current = (title || '').trim();
  if (current && !isDayName(current)) return title;
  return dayName(date.getDay(), i18n.language);
}
